<template>
  <div class="refund-compensation-summary">
    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-4">
        <div class="refund-compensation-summary__card">
          <span class="refund-compensation-summary__label">
            Valor residual para restituição
          </span>
          <strong class="refund-compensation-summary__value">
            {{ formatCurrencyBRL(compensationData.refundValue) }}
          </strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formatCurrencyBRL,
  hasInstallmentToChangeValue,
} from '../utils/refundCompensation';

export default {
  name: 'RefundCompensationSummary',
  props: {
    compensationData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    canceledInstallments() {
      return Array.isArray(this.compensationData.installmentsToCancel)
        ? this.compensationData.installmentsToCancel.length
        : 0;
    },
    hasChangedInstallment() {
      return hasInstallmentToChangeValue(this.compensationData);
    },
  },
  methods: {
    formatCurrencyBRL,
  },
};
</script>

<style lang="scss" scoped>
.refund-compensation-summary__card {
  height: 100%;
  padding: 16px;
  border: 1px solid #dfe3e8;
  border-radius: 12px;
  background: #f8fafc;
}

.refund-compensation-summary__label {
  display: block;
  margin-bottom: 8px;
  color: #6b7280;
  font-size: 0.875rem;
}

.refund-compensation-summary__value {
  color: #111827;
  font-size: 1.25rem;
}
</style>
